import { Table } from 'antd';
import { useTranslation } from 'react-i18next';
import type { MydayType } from '../../fetchHooks/useMyday.ts';
import { useMydayTable } from '../../hooks/useMydayTable';
import { createMydayColumns } from '../../utils/tableColumns';
import { MyDayVariant } from './MyDayPage.tsx';
import { tableSkeleton } from './NotesTable.tsx';

interface ExperiencesTableProps {
  setShowEditMydayModal: (item: MydayType) => void;
}

export const ExperiencesTable = ({ setShowEditMydayModal }: ExperiencesTableProps) => {
  const { t, i18n } = useTranslation();

  const { mydays, pagination, isLoadingMydays, tablePagination, handleShowMydayDetails, handleDeleteMyday } =
    useMydayTable(MyDayVariant.EXPERIENCE);

  const columns = createMydayColumns(t, i18n.language, {
    onView: handleShowMydayDetails,
    onEdit: setShowEditMydayModal,
    onDelete: handleDeleteMyday,
  });

  return (
    <>
      <Table
        dataSource={isLoadingMydays ? tableSkeleton() : mydays}
        scroll={{ x: true }}
        sticky
        loading={isLoadingMydays}
        bordered
        size="small"
        columns={columns as any}
        rowKey="id"
        style={{ marginBottom: 16 }}
        pagination={tablePagination}
      />
      {t('myday.showingExperienceEntries', { count: mydays.length, total: pagination?.total || mydays.length })}
    </>
  );
};
